/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.
import { getRuntimeConfig } from 'helpers/runtimeConfig';

const awsmobile = () => ({
  aws_project_region: 'eu-west-1',
  aws_cognito_region: 'eu-west-1',
  aws_user_pools_id: getRuntimeConfig().env.REACT_APP_COGNITO_USER_POOL_ID,
  aws_user_pools_web_client_id: getRuntimeConfig().env.REACT_APP_COGNITO_USER_POOL_WEB_CLIENT_ID,
  oauth: {
    domain: getRuntimeConfig().env.REACT_APP_COGNITO_HOSTED_UI_DOMAIN,
    scope: ['phone', 'email', 'openid'],
    redirectSignIn: window.location.origin,
    redirectSignOut: window.location.origin,
    responseType: 'code',
  },
  aws_cognito_username_attributes: ['EMAIL'],
  aws_cognito_social_providers: [],
  aws_cognito_signup_attributes: ['EMAIL'],
  aws_cognito_mfa_configuration: 'OPTIONAL',
  aws_cognito_mfa_types: ['SMS'],
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [],
  },
  aws_cognito_verification_mechanisms: ['EMAIL'],
});

export default awsmobile;
